module.exports = __webpack_public_path__ + "img/textura-elvas-3@3x.9f14ee8a.png";